import React from 'react'

const OfferIcon = props => {
  return (
    <svg
      width="18"
      height="14"
      viewBox="0 0 18 14"
      fill={props.fill}
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M3.33341 17.4994C2.87508 17.4994 2.48286 17.3363 2.15675 17.0102C1.83008 16.6835 1.66675 16.291 1.66675 15.8327V6.66602C1.66675 6.20768 1.83008 5.81546 2.15675 5.48935C2.48286 5.16268 2.87508 4.99935 3.33341 4.99935H6.66675V3.33268C6.66675 2.87435 6.83008 2.48185 7.15675 2.15518C7.48286 1.82907 7.87508 1.66602 8.33341 1.66602H11.6667C12.1251 1.66602 12.5176 1.82907 12.8442 2.15518C13.1704 2.48185 13.3334 2.87435 13.3334 3.33268V4.99935H16.6667C17.1251 4.99935 17.5176 5.16268 17.8442 5.48935C18.1704 5.81546 18.3334 6.20768 18.3334 6.66602V15.8327C18.3334 16.291 18.1704 16.6835 17.8442 17.0102C17.5176 17.3363 17.1251 17.4994 16.6667 17.4994H3.33341ZM8.33341 4.99935H11.6667V3.33268H8.33341V4.99935Z" />
    </svg>
  )
}

export default OfferIcon
